export default "__VITE_ASSET__XEc2rVYs__"